module.exports = __webpack_public_path__ + "static/media/Evora 1.04eced09.png";